import Layout from '../components/Layout';
import Contact from '../components/Contact';

export default () => (
  <Layout>
    <div className="container">
      <h2 className="mb-30">Parallel AAD-C C++ Library</h2>
      <div className="text-justify">
        <p>
          AAD-C(patent pending) is a novel approach to implement automatic adjoint differentiation of C++ programs with focus on computations where derivatives are required for multiple instances of input data. It combines easy to integrate Operator Overloading techniques and beats the efficiency of code transformation. Automatic vectorization and our unique approach allows to achieve performance unseen before.
          Order of 50 times speed up compared to single valuation of the original function.
          I.e. for just 2% of the original code execution time you get values of the base algorithm and all its derivatives.
        </p>
      </div>
      <div className="row mt-30">
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-diamond"></span>
              Efficient memory
            </h4>
            <p>Very large computations are possible. Efficient memory use for the original algorithm and adjoint version.</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-sync"></span>
              Automatic vectorization
            </h4>
            <p>Take full advantage of AVX2 or AVX512 native CPU vectorization</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-rocket"></span>
              Multi-thread safe
            </h4>
            <p>Output functions are safe to execute in parallel even when the original code is not.</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-magic-wand"></span>
              AAD Checkpoints
            </h4>
            <p>Support for all modern AAD features, such as external functions and check-pointing.</p>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-eye"></span>
              Easy integration
            </h4>
            <p>No template expressions. Unique active type allows to reuse in-memory objects for AAD.</p>
          </div>
        </div>
        <div className="col-lg-4 col-md-6">
          <div className="single-service">
            <h4>
              <span className="lnr lnr-code"></span>
              Automatically tested
            </h4>
            <p>Automatically tested on multiple platforms/compilers using rich set of test cases</p>
          </div>
        </div>
      </div>
      <Contact/>
    </div>
  </Layout>
)